export enum UnsubscribeQueryRequiredParamsName {
  Address = 'address',
  IsGroup = 'is_group',
}

export enum UnsubscribeQueryNotRequiredParamsName {
  IsMember = 'is_member',
}

export type UnsubscribeQueryParamsName =
  | UnsubscribeQueryRequiredParamsName
  | UnsubscribeQueryNotRequiredParamsName;
export const UnsubscribeQueryParamsNameObj = {
  ...UnsubscribeQueryRequiredParamsName,
  ...UnsubscribeQueryNotRequiredParamsName,
};

export interface UnsubscribeQueryParams {
  [UnsubscribeQueryParamsNameObj.Address]: string;
  [UnsubscribeQueryParamsNameObj.IsGroup]: string;
  [UnsubscribeQueryParamsNameObj.IsMember]?: string;
}
